import { render, staticRenderFns } from "./PartnerManufacturerShowcasesTable.vue?vue&type=template&id=08ea4eae&"
import script from "./PartnerManufacturerShowcasesTable.vue?vue&type=script&lang=js&"
export * from "./PartnerManufacturerShowcasesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports